import { i18n } from "@/plugins/i18n"

export const makeEpisodeRoutes = ({ listName, createName, detailName, editName, parent }) => [
  {
    path: "episodes",
    component: () => import("@/views/Podcasts/Episodes/PodcastEpisodes.vue"),
    children: [
      {
        path: "",
        name: listName,
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeList.vue"),
        meta: {
          pageTitle: i18n.t("episodes.list_title"),
          parent,
          rule: "owner",
        },
      },
      {
        path: "create",
        name: createName,
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeAdd.vue"),
        props: true,
        meta: {
          pageTitle: i18n.t("episodes.add_title"),
          parent,
          rule: "owner",
        },
      },
      {
        path: ":episodeKey",
        name: detailName,
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisode.vue"),
        props: true,
        meta: {
          pageTitle: i18n.t("episodes.detail_title"),
          parent,
          rule: "owner",
        },
        children: [
          {
            path: "edit",
            name: editName,
            component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeEdit.vue"),
            props: true,
            meta: {
              pageTitle: i18n.t("episodes.settings_title"),
              parent,
              rule: "owner",
            },
          },
        ],
      },
    ],
  },
]
